export const OfflineStorageKeyAllowAutoRefresh = "esitqapp-allow-auto-refresh";
